export default __webpack_public_path__ + "static/logo-black-6deea63415a4c217915d383abf7950e3.png";